import {AppenderConfig} from '../appenderConfig';

/**
 * Console appender config
 */
export class ConsoleAppenderConfig extends AppenderConfig {

}
